import { TMasterLanguageTestLevel } from "@/api/entities/master-language-test.entity";
import { setHiddenLanguageTestLevelApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenLanguageTestLevelModalProps = {
  hiddenLevel?: TMasterLanguageTestLevel;
  setHiddenLevel: Dispatch<SetStateAction<TMasterLanguageTestLevel | undefined>>;
  setSelectedLevelRows: React.Dispatch<React.SetStateAction<TMasterLanguageTestLevel[]>>;
};

export const HiddenLanguageTestLevelModal: FC<THiddenLanguageTestLevelModalProps> = ({ hiddenLevel, setHiddenLevel, setSelectedLevelRows }) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenLevel) return;
    try {
      const rs = await setHiddenLanguageTestLevelApi(hiddenLevel.languageTestId, hiddenLevel.id, { isHidden: !hiddenLevel.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      setSelectedLevelRows((prev) => {
        const arr = prev.map((item) => (toNumber(item.id) === toNumber(rs.data.id) ? rs.data : item));
        return arr;
      });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_LANGUAGE_TEST] });
    } catch (error) {
      showError(error);
    } finally {
      setHiddenLevel(undefined);
    }
  };

  return (
    <Modal
      title={hiddenLevel?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenLevel}
      onClose={() => setHiddenLevel(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenLevel?.isHidden
          ? `「${hiddenLevel?.level}」を有効にしてもよろしいですか？`
          : `「${hiddenLevel?.level}」を無効にしてもよろしいですか？`}
      </Typography>
    </Modal>
  );
};
